import type { safeAny } from "../types/safeAny.types";

/**
 * Builds a query string from an object, encoding string values and appending to a URL
 * @param url - The base URL to append the query string to
 * @param params - Object with query parameters (null/undefined values are skipped)
 * @returns The URL with appended query string (including leading '?') or the original URL if no valid parameters
 */
export function buildQueryString(url: string, params: Record<string, safeAny>): string {
  const query = Object.entries(params)
    .filter(([_, value]) => value != null)
    .map(([key, value]) => {
      const encodedValue = typeof value === 'string' 
        ? encodeURIComponent(value) 
        : String(value);
      return `${key}=${encodedValue}`;
    })
    .join('&');
  
  return query ? `${url}?${query}` : url;
}
